// LucideIcon.jsx
import * as Icons from 'lucide-react';

const LucideIcon = ({ name, color = '#00ffff', backgroundColor = '#4361ee' , ...props }) => {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    return <span>Invalid icon: {name}</span>;
  }

  return <IconComponent color={color} {...props} backgroundColor={backgroundColor} />;
};

export default LucideIcon;
